import React, { useState } from "react";

const BulkUploadResults = ({ results, onClose }) => {
  const [activeTab, setActiveTab] = useState('successful');

  if (!results) return null;

  const { summary, results: detailedResults } = results;

  const renderUserList = (users, type) => {
    if (!users || users.length === 0) {
      return (
        <div className="text-center py-20">
          <p className="text-light-1">No {type} users to display</p>
        </div>
      );
    }

    return (
      <div className="table-responsive">
        <table className="table table-striped">
          <thead>
            <tr>
              <th>Row</th>
              <th>Email</th>
              {type === 'successful' && <th>Full Name</th>}
              {type !== 'successful' && <th>Error</th>}
            </tr>
          </thead>
          <tbody>
            {users.map((user, index) => (
              <tr key={index}>
                <td>{user.row}</td>
                <td>{user.email}</td>
                {type === 'successful' && <td>{user.fullName}</td>}
                {type !== 'successful' && <td className="text-danger">{user.error}</td>}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    );
  };

  return (
    <div className="modal fade show" style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.5)' }}>
      <div className="modal-dialog modal-xl">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">Bulk Upload Results</h5>
            <button type="button" className="btn-close" onClick={onClose}></button>
          </div>
          
          <div className="modal-body">
            {/* Summary */}
            <div className="row mb-30">
              <div className="col-12">
                <div className="bg-light rounded-16 px-20 py-20">
                  <h6 className="text-16 fw-500 mb-15">Upload Summary</h6>
                  <div className="row">
                    <div className="col-sm-3 col-6">
                      <div className="text-center">
                        <div className="text-24 fw-700 text-dark">{summary.totalProcessed}</div>
                        <div className="text-12 text-dark">Total Processed</div>
                      </div>
                    </div>
                    <div className="col-sm-3 col-6">
                      <div className="text-center">
                        <div className="text-24 fw-700 text-green-1">{summary.successful}</div>
                        <div className="text-12 text-dark">Users Created</div>
                      </div>
                    </div>
                    <div className="col-sm-3 col-6">
                      <div className="text-center">
                        <div className="text-24 fw-700 text-orange-1 ">{summary.duplicates}</div>
                        <div className="text-12 text-dark">Duplicates</div>
                      </div>
                    </div>
                    <div className="col-sm-3 col-6">
                      <div className="text-center">
                        <div className="text-24 fw-700 text-red-1">{summary.failed}</div>
                        <div className="text-12 text-dark">Failed</div>
                      </div>
                    </div>
                  </div>
                  
                  {/* Email Status */}
                  {(summary.emailsSent !== undefined || summary.emailsFailed !== undefined) && (
                    <div className="row mt-20 pt-20 border-top-light">
                      <div className="col-12 mb-10">
                        <h6 className="text-14 fw-500 text-dark-1">📧 Email Status</h6>
                      </div>
                      <div className="col-sm-6">
                        <div className="text-center">
                          <div className="text-20 fw-700 text-green-1">{summary.emailsSent || 0}</div>
                          <div className="text-12 text-dark">Emails Sent</div>
                        </div>
                      </div>
                      <div className="col-sm-6">
                        <div className="text-center">
                          <div className="text-20 fw-700 text-red-1">{summary.emailsFailed || 0}</div>
                          <div className="text-12 text-dark">Email Failures</div>
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>

            {/* Tabs */}
            <div className="tabs -active-purple-2 js-tabs">
              <div className="tabs__controls d-flex x-gap-30 y-gap-20 flex-wrap items-center border-bottom-light">
                <button
                  className={`tabs__button text-light-1 ${activeTab === 'successful' ? 'is-active' : ''}`}
                  onClick={() => setActiveTab('successful')}
                  type="button"
                >
                  Successful ({summary.successful})
                </button>
                <button
                  className={`tabs__button text-light-1 ${activeTab === 'duplicates' ? 'is-active' : ''}`}
                  onClick={() => setActiveTab('duplicates')}
                  type="button"
                >
                  Duplicates ({summary.duplicates})
                </button>
                <button
                  className={`tabs__button text-light-1 ${activeTab === 'failed' ? 'is-active' : ''}`}
                  onClick={() => setActiveTab('failed')}
                  type="button"
                >
                  Failed ({summary.failed})
                </button>
              </div>

              <div className="tabs__content py-20">
                {/* Successful Users */}
                <div className={`tabs__pane ${activeTab === 'successful' ? 'is-active' : ''}`}>
                  {renderUserList(detailedResults.successful, 'successful')}
                </div>

                {/* Duplicate Users */}
                <div className={`tabs__pane ${activeTab === 'duplicates' ? 'is-active' : ''}`}>
                  {renderUserList(detailedResults.duplicates, 'duplicates')}
                </div>

                {/* Failed Users */}
                <div className={`tabs__pane ${activeTab === 'failed' ? 'is-active' : ''}`}>
                  {renderUserList(detailedResults.failed, 'failed')}
                </div>
              </div>
            </div>
          </div>

          <div className="modal-footer">
            <button type="button" className="button -md bg-purple-1 text-white" onClick={onClose}>
              Close
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BulkUploadResults; 